import { useEffect } from 'react';

// Custom hook for Google Analytics tracking
const useVisitorTracking = () => {

  // Track page views
  const trackPageView = (pageName = 'Home') => {
    // Send to Google Analytics if available
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        custom_parameter_1: 'tourism_page_view'
      });
    }
  };

  // Track custom events
  const trackEvent = (eventName, eventData = {}) => {
    // Send to Google Analytics if available
    if (window.gtag) {
      window.gtag('event', eventName, {
        event_category: 'tourism_interaction',
        event_label: eventData.label || eventName,
        value: eventData.value || 1,
        custom_parameter_1: 'tourism_event'
      });
    }
  };

  // Initialize tracking on mount
  useEffect(() => {
    // Track initial page view
    trackPageView('Landing Page');

    // Track visitor engagement metrics
    let startTime = Date.now();

    const handleVisibilityChange = () => {
      if (document.hidden) {
        const timeSpent = Date.now() - startTime;
        trackEvent('session_pause', { timeSpent });
      } else {
        startTime = Date.now();
        trackEvent('session_resume');
      }
    };

    const handleBeforeUnload = () => {
      const timeSpent = Date.now() - startTime;
      trackEvent('session_end', { timeSpent, totalSessionTime: timeSpent });
    };

    // Add event listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Track scroll depth for engagement
    let maxScrollDepth = 0;
    const handleScroll = () => {
      const scrollDepth = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );
      if (scrollDepth > maxScrollDepth) {
        maxScrollDepth = scrollDepth;
        if (maxScrollDepth % 25 === 0 && maxScrollDepth > 0) {
          trackEvent('scroll_depth', { depth: maxScrollDepth });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    trackPageView,
    trackEvent,
  };
};

export default useVisitorTracking;
